// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.icon i {
  line-height: 100%;
  display: block;
}
.icon.offset-top-1px {
  padding-top: 1px;
}
.icon.offset-top-2px {
  padding-top: 2px;
}
.icon.offset-top-3px {
  padding-top: 3px;
}
.icon.offset-top-4px {
  padding-top: 4px;
}
.icon.offset-bottom-1px {
  padding-bottom: 1px;
}
.icon.offset-bottom-2px {
  padding-bottom: 2px;
}
.icon.offset-bottom-3px {
  padding-bottom: 3px;
}
.icon.offset-bottom-4px {
  padding-bottom: 4px;
}
.icon.offset-left-1px {
  padding-left: 1px;
}
.icon.offset-left-2px {
  padding-left: 2px;
}
.icon.offset-left-3px {
  padding-left: 3px;
}
.icon.offset-left-4px {
  padding-left: 4px;
}
.icon.offset-right-1px {
  padding-right: 1px;
}
.icon.offset-right-2px {
  padding-right: 2px;
}
.icon.offset-right-3px {
  padding-right: 3px;
}
.icon.offset-right-4px {
  padding-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Icon.scss"],"names":[],"mappings":"AAAA;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACE,iBAAA;EACA,cAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAME;EACE,kBAAA;AAJJ","sourcesContent":[".icon {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  i{\r\n    line-height: 100%;\r\n    display: block;\r\n  }\r\n\r\n  &.offset-top-1px{\r\n    padding-top: 1px;\r\n  }\r\n  &.offset-top-2px{\r\n    padding-top: 2px;\r\n  }\r\n  &.offset-top-3px{\r\n    padding-top: 3px;\r\n  }\r\n  &.offset-top-4px{\r\n    padding-top: 4px;\r\n  }\r\n\r\n  &.offset-bottom-1px{\r\n    padding-bottom: 1px;\r\n  }\r\n  &.offset-bottom-2px{\r\n    padding-bottom: 2px;\r\n  }\r\n  &.offset-bottom-3px{\r\n    padding-bottom: 3px;\r\n  }\r\n  &.offset-bottom-4px{\r\n    padding-bottom: 4px;\r\n  }\r\n\r\n  &.offset-left-1px{\r\n    padding-left: 1px;\r\n  }\r\n  &.offset-left-2px{\r\n    padding-left: 2px;\r\n  }\r\n  &.offset-left-3px{\r\n    padding-left: 3px;\r\n  }\r\n  &.offset-left-4px{\r\n    padding-left: 4px;\r\n  }\r\n\r\n  &.offset-right-1px{\r\n    padding-right: 1px;\r\n  }\r\n  &.offset-right-2px{\r\n    padding-right: 2px;\r\n  }\r\n  &.offset-right-3px{\r\n    padding-right: 3px;\r\n  }\r\n  &.offset-right-4px{\r\n    padding-right: 4px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
